import moment from 'moment';

const IMAGE_SERVER = process.env.VUE_APP_IMAGE_SERVER;
const VIDEO_SERVER = process.env.VUE_APP_VIDEO_SERVER;

export function checkMobile() {
    var userAgent = navigator.userAgent;
    var mobile = /(iPhone|iPad|Android|BlackBerry|Windows Phone)/i.test(userAgent);
    if(mobile){
        return true;
    }else{
        return false;
    }
}

export function toHex(str) {
    let result = '';
    for (let i=0; i<str.length; i++) {
        result += str.charCodeAt(i).toString(16);
    }
    return result;
}

export function convertFormData(data){
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
        type: 'application/json'
    });

    return blob;
}

export function encodeFormData(formData) {
    const params = new URLSearchParams();
    for (const pair of formData.entries()) {
    params.append(pair[0], pair[1]);
    }
    return params.toString();
}

export function showImage(image_url){


    if(image_url == "profile_default.jpg"){
        return require("@/assets/img/default_profile.png");
    }else{
        return IMAGE_SERVER + image_url;
    }

}

export function showVideo(video_url){
    return VIDEO_SERVER + video_url;

}

export function convertTelFomat(phoneNumber) {

    let res ='';

    if(!phoneNumber) return res

    phoneNumber = phoneNumber.replace(/[^0-9]/g, "");

    if(!phoneNumber) return res

    if(phoneNumber.length < 3) {
        res = phoneNumber
    }
    else {
        if(phoneNumber.substr(0, 2) =='02') {

            if(phoneNumber.length <= 5) {//02-123-5678
                res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3)
            }
            else if(phoneNumber.length > 5 && phoneNumber.length <= 9) {//02-123-5678
                res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3) + '-' + phoneNumber.substr(5)
            }
            else if(phoneNumber.length > 9) {//02-1234-5678
                res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 4) + '-' + phoneNumber.substr(6)
            }

        } else {
            if(phoneNumber.length < 8) {
                res = phoneNumber
            }
            else if(phoneNumber.length == 8)
            {
                res = phoneNumber.substr(0, 4) + '-' + phoneNumber.substr(4)
            }
            else if(phoneNumber.length == 9)
            {
                res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6)
            }
            else if(phoneNumber.length == 10)
            {
                res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6)
            }
            else if(phoneNumber.length > 10) { //010-1234-5678
                res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 4) + '-' + phoneNumber.substr(7)
            }
        }
    }
            
    return res;

}

export function convertDateFormat(date, type){
    switch(type){
    case 'none' : return moment(date).format('YYYYMMDD');
    case 'hyphen' : return moment(date).format('YYYY-MM-DD');
    case 'dot' : return moment(date).format('YYYY.MM.DD');
    case 'kor' : return moment(date).format('YYYY년 MM월 DD일');
    case 'date' : return moment(date).format('A hh:mm');
    default : return date;
    }
}

// 생년월일 문자열(구분자 무관, 19900101 / 1990-01-01 / 1990.01.01 등)을 받아 "만 N세" 반환.
// 파싱 실패하거나 비정상 범위면 빈 문자열.
export function getAgeFromBirth(birthDateStr){
    if(!birthDateStr) return '';
    const digits = String(birthDateStr).replace(/[^0-9]/g, '');
    if(digits.length !== 8) return '';

    const birth = moment(digits, 'YYYYMMDD', true);
    if(!birth.isValid()) return '';

    const age = moment().diff(birth, 'years');
    if(age < 0 || age > 130) return '';

    return '만 ' + age + '세';
}

//v-html 로 출력하는 값의 HTML 특수문자 무력화 (입력값에 태그·스크립트가 있어도 글자로만 보이게) — 저장형 XSS 방지
export function escapeHtml(text) {
    if (text === null || text === undefined) return '';
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function replaceLineBr(text) {
    if(text){
    return text.replace("\n", "<br/>");
    }
}

export function convertShortCity(city){
    switch(city){
    case "서울특별시" : return "서울";
    case "부산광역시" : return "부산";
    case "대구광역시" : return "대구";
    case "인천광역시" : return "인천";
    case "광주광역시" : return "광주";
    case "세종특별자치시" : return "세종";
    case "대전광역시" : return "대전";
    case "울산광역시" : return "울산";
    case "경기도" : return "경기";
    case "강원도" : return "강원";
    case "충청북도" : return "충북";
    case "충청남도" : return "충남";
    case "전라북도" : return "전북";
    case "전라남도" : return "전남";
    case "경상북도" : return "경북";
    case "경상남도" : return "경남";
    case "제주특별자치도" : return "제주";
    default : return city;
    }
}

export function convertShortCountry(country){
    if(country.length >= 3){
    if(country.indexOf('시') || country.indexOf('군') || country.indexOf('구')){

        if(country == '세종특별자치시' || country == '제주특별자치도' || country == '창원마산합포회원구' || country == '창원의창성산구' || country == '창원진해구'){
        country = country.substr(0, 2);

        return country;
        }
        country = country.slice(0, -1);

        return country;
    }
    }else{
    return country;
    }
}

export function resizeImage(file) {

    let maxWidth = 800;

    return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function(event) {
        const img = new Image();

        img.onload = function() {
        if (img.width <= maxWidth) {
            // 이미지 폭이 maxWidth보다 작으면 원본 이미지를 반환합니다.
            resolve(file);
            return;
        }

        const aspectRatio = img.width / img.height;
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const newWidth = maxWidth;
        
        const newHeight = newWidth / aspectRatio;

        canvas.width = newWidth;
        canvas.height = newHeight;

        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        canvas.toBlob(
            blob => {
            resolve(new File([blob], file.name, { type: file.type }));
            },
            file.type,
            0.8 // 이미지 품질, 0.8은 80% 품질을 의미합니다.
        );
        };

        img.src = event.target.result;
    };

    reader.readAsDataURL(file);
    });
}

export function extractDetailAddressFlexible(address) {
  let parts = address.split(' ');
  // 보통 3단계 이상이면 3번째부터, 그렇지 않으면 2번째부터
  let place = parts.length >= 3 ? 2 : 1;
  return parts.slice(place).join(' ');
}